import React from 'react'
import { motion } from 'framer-motion';
import techStack from '../../images/tech-stack.png';
import servicebg from '../../images/testimonial-bg.png';

function TechStack() {
    return (
        <section id="tech-stack" className="tech-section" style={{ backgroundImage: `url(${servicebg})` }}>
            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}>
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">Technologies We <span className="highlight-orange">Root</span> For
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-3">
                    <span className="text-center fw-bold" style={{ fontSize: '22px', color: '#000', fontWeight: '500' }}>
                        Your Business Partners to Navigate the <span className="highlight-orange">Digital Landscape  </span> with   <span className="highlight-orange"> Latest Technology </span>
                    </span>
                </div>
                {/* <div className="d-flex justify-content-center mt-4">
                        <a
                            href="#contact-us"
                            className="btn custom-orange-btn py-3 px-4 fw-bold"
                        >
                            Get in Touch With Us
                        </a>
                    </div> */}
            </motion.section>

            <div className="container my-5">
                <motion.img
                    src={techStack}
                    alt="Descriptive alt text"
                    className="img-fluid rounded w-100"
                    style={{ objectFit: 'cover' }}
                    initial={{ y: 30, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: false, amount: 0.6 }}
                    transition={{ duration: 0.8, ease: "easeOut" }} />
            </div>
        </section>
    )
}

export default TechStack